globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.Settings = appCustomerSpace.Modals.Settings || {};

appCustomerSpace.Modals.Settings.AddMediaLogos = (function(superClass) {

  utils.extend(AddMediaLogos, superClass);

  function AddMediaLogos() {
    this.ajaxResourcePath = "/configuration/mediatheque/logos";

    return AddMediaLogos.__super__.constructor.apply(this, arguments);
  }

  $.extend(AddMediaLogos.prototype, {
    init: function() {
      return AddMediaLogos.__super__.init.apply(this, arguments);
    }
  });

  return AddMediaLogos;

})(appCustomerSpace.Modals.Settings.AddMediaAbstractFiles);
